import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../services/supabaseClient';
import { buildNormalizedUser } from '../contexts/AuthContext';
import SafeheirLogo from '../components/SafeheirLogo';

const AuthCallback = () => {
  const navigate = useNavigate();
  const navigated = useRef(false);

  const resolveDestination = (user) => {
    if (!user) return '/login';
    return user.onboarding_completed ? '/dashboard' : '/onboarding';
  };

  useEffect(() => {
    if (!supabase) {
      navigate('/login', { state: { error: 'Configuration Supabase manquante' } });
      return;
    }

    const failureTimeout = setTimeout(() => {
      if (!navigated.current) {
        navigated.current = true;
        navigate('/login', { state: { error: 'Lien expiré ou invalide' } });
      }
    }, 5000);

    const timer = setTimeout(async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (!navigated.current) {
          navigated.current = true;
          clearTimeout(failureTimeout);
          if (session?.user?.email_confirmed_at) {
            const normalizedUser = await buildNormalizedUser(session.user);
            navigate(resolveDestination(normalizedUser));
          } else {
            navigate('/login', { state: { error: 'Lien expiré ou invalide' } });
          }
        }
      } catch {
        if (!navigated.current) {
          navigated.current = true;
          clearTimeout(failureTimeout);
          navigate('/login', { state: { error: 'Lien expiré ou invalide' } });
        }
      }
    }, 500);

    return () => {
      clearTimeout(timer);
      clearTimeout(failureTimeout);
    };
  }, [navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      background: '#0A1628',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: '2rem',
    }}>
      <SafeheirLogo size="lg" />

      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: 40,
          height: 40,
          border: '3px solid rgba(255,255,255,0.1)',
          borderTopColor: '#00F5A0',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
          margin: '0 auto 1rem',
        }} />
        <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: 14, margin: 0 }}>
          Vérification de votre compte...
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;
